export default {
  data() {
    return {
      isRecording: false,
      recognition: null,
      interimTranscript: "",
      silenceTimeout: null,
      silenceTimeoutDuration: 3000,
    };
  },
  methods: {
    initSpeechRecognition() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!SpeechRecognition) {
        console.warn("Speech recognition is not supported in this browser");
        return false;
      }

      this.recognition = new SpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = "en-US";

      this.recognition.onresult = (event) => {
        let interimText = "";
        let finalText = "";

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalText += transcript + " ";
          } else {
            interimText += transcript;
          }
        }

        if (finalText || interimText) {
          this.resetSilenceTimeout();
        }

        if (finalText) {
          this.onVoiceTextRecognized({
            type: "final",
            text: finalText,
            interimText: this.interimTranscript,
          });
          this.interimTranscript = "";
        } else if (interimText) {
          this.onVoiceTextRecognized({
            type: "interim",
            text: interimText,
            interimText: this.interimTranscript,
          });
          this.interimTranscript = interimText;
        }
      };

      this.recognition.onerror = (event) => {
        console.error("Speech recognition error:", event.error);
        if (event.error === "no-speech" || event.error === "audio-capture") {
          this.stopVoiceRecognition();
        }
        this.onVoiceRecognitionError(event.error);
      };

      this.recognition.onend = () => {
        if (this.isRecording) {
          this.recognition.start();
        }
      };

      return true;
    },
    toggleVoiceRecognition() {
      if (!this.recognition && !this.initSpeechRecognition()) {
        alert("Speech recognition is not supported in your browser. Please use Chrome, Edge, or Safari.");
        return;
      }

      if (this.isRecording) {
        this.stopVoiceRecognition();
      } else {
        this.startVoiceRecognition();
      }
    },
    startVoiceRecognition() {
      if (!this.recognition) {
        if (!this.initSpeechRecognition()) {
          return;
        }
      }

      try {
        this.isRecording = true;
        this.recognition.start();
        this.startSilenceTimeout();
        this.onVoiceRecordingStarted();
      } catch (error) {
        console.error("Error starting speech recognition:", error);
        this.isRecording = false;
        this.clearSilenceTimeout();
        this.onVoiceRecognitionError(error.message);
      }
    },
    stopVoiceRecognition() {
      this.clearSilenceTimeout();
      if (this.recognition) {
        try {
          this.recognition.stop();
        } catch (error) {
          console.error("Error stopping speech recognition:", error);
        }
      }
      this.isRecording = false;
      this.onVoiceRecordingStopped({
        interimText: this.interimTranscript,
      });
      this.interimTranscript = "";
    },
    startSilenceTimeout() {
      this.clearSilenceTimeout();
      this.silenceTimeout = setTimeout(() => {
        if (this.isRecording) {
          this.onSilenceTimeoutReached();
          // Check again if still recording, as the hook might have stopped it
          if (this.isRecording) {
            this.stopVoiceRecognition();
          }
        }
      }, this.silenceTimeoutDuration);
    },
    resetSilenceTimeout() {
      if (this.isRecording) {
        this.startSilenceTimeout();
      }
    },
    clearSilenceTimeout() {
      if (this.silenceTimeout) {
        clearTimeout(this.silenceTimeout);
        this.silenceTimeout = null;
      }
    },
    setSilenceTimeoutDuration(duration) {
      this.silenceTimeoutDuration = duration;
    },
    // Hook methods that should be implemented by components using this mixin
    onVoiceTextRecognized(event) {
      // Override this method in the component
    },
    onVoiceRecordingStarted() {
      // Override this method in the component
    },
    onVoiceRecordingStopped(event) {
      // Override this method in the component
    },
    onVoiceRecognitionError(error) {
      // Override this method in the component
    },
    onSilenceTimeoutReached() {
      // Override this method in the component to handle silence timeout
      // This is called before stopping the recording
    },
  },
  beforeUnmount() {
    this.clearSilenceTimeout();
    this.stopVoiceRecognition();
  },
};
